<template>
  <div class="search-pages">
    <component :is="view" @close="cancelSearch"></component>
  </div>
</template>

<script>
import Search from '../components/SearchForProducts'
export default {
  name: 'searchPage',
  components: {
    Search
  },
  data () {
    return {
      view: null
    }
  },
  methods: {
    cancelSearch () {
      this.view = null
      this.$router.back()
    }
  },
  activated () {
    this.view = Search
  },
  deactivated () {
    if (this.$route.name !== 'productDetails') {
      this.view = null
    }
  }
}
</script>

<style lang="less" scoped>
</style>
